import { t } from "@repo/translation";
import { isToday, isTomorrow } from "date-fns";

interface LocalizedDayProps {
  date: string | Date;
}

export const LocalizedDay = ({ date }: LocalizedDayProps) => {
  return <>{localizeDay(date)}</>;
};

export const localizeDay = (date: string | Date) => {
  const d = date instanceof Date ? date : new Date(date);
  const today = new Date();

  if (isToday(d)) {
    return t("label.today");
  }

  if (isTomorrow(d)) {
    return t("label.tomorrow");
  }

  if (d < today) {
    return t("label.passed");
  }

  return t("label.future");
};
